import React, {useState, useEffect, useRef} from 'react';
import {connect} from 'react-redux';
import BackButton from '../partials/BackButton/BackButton';
import {
  resetPageCallsDetails,
  setShowSortingPopup,
  saveCallsSorting,
  resetSortingData,
  resetLoginErrorCallDetails,
  selectedCallType,
  goToPage,
  setCallsDetailsPopUp,
} from '../PersonalAreaInvoicesSlice';
import {
  getCallsMainAsync,
  getCallsListAsync,
  getCallsLogAuthAsync,
  getCallsLogAuthCheckLoginAsync,
} from '../PersonalAreaInvoicesAsyncThunk';
import CallDetailsPopUp from '../partials/CallsDetails/CallDetailsPopUp/CallDetailsPopUp';
import Subscribers from '../partials/CallsDetails/Subscribers/Subscribers';
import CallType from '../partials/CallsDetails/CallType/CallType';
import CallsDetails from '../partials/CallsDetails/CallsDetails/CallsDetails';
import Login from '../partials/CallsDetails/Login/Login';

function CallsDetailsPage(props) {
  let currentView = null;
  let backBtnText = '';

  useEffect(() => {
    window.scroll(0, 0);
    return () => {};
  }, []);

  switch (props.page) {
    case 'login':
      backBtnText = 'חזרה';
      currentView = <Login onClickButton={handleOnClickButton} loginParam={props.loginParam} error={props.loginError} />;
      break;
    case 'subscribers':
      backBtnText = 'חזרה';
      currentView = <Subscribers subscribers={props.subscribers} onClickSubscriber={handleOnClickSubscriber} />;
      break;
    case 'callType':
      backBtnText = 'חזרה';
      currentView = <CallType callsDetails={props.callsDetails} onClickCallType={handleOnClickCallType} />;
      break;
    case 'callsDetails':
      backBtnText = 'חזרה';
      const callsDetails = props.callsDetails.find((item) => item.selected == true);
      currentView = (
        <CallsDetails
          callsDetails={callsDetails}
          showSortingPopup={props.showSortingPopup}
          toggleSortingPopup={handleToggleSortingPopup}
          sortingData={props.sortingData}
          selectedSort={props.selectedSort}
          onClickSaveSorting={handleOnClickSaveSorting}
          onResetSort={handleResetSortingData}
          onClickRemoveSort={handleResetSortingData}
        />
      );
      break;
    default:
      break;
  }

  function handleOnClickButton(form) {
    props.resetLoginErrorCallDetails();
    props.getCallsLogAuthCheckLoginAsync(form);
  }

  function handleOnClickSubscriber(subscriber) {
    props.getCallsLogAuthAsync(subscriber);
  }

  function handleOnClickCallType(type) {
    props.selectedCallType(type);
    props.goToPage('callsDetailsPage_callsDetails');
  }

  function handleToggleSortingPopup(isOpen, type) {
    props.setShowSortingPopup({isOpen: isOpen, type: type});
  }

  function handleOnClickSaveSorting(sortingData) {
    props.saveCallsSorting(sortingData);
    props.setShowSortingPopup({isOpen: false});
  }

  function handleResetSortingData() {
    props.resetSortingData();
  }

  function onClickBackButton() {
    if (props.previousPage == 'login') {
      props.resetPageCallsDetails();
      window.history.go(-2);
    } else {
      window.history.back();
    }
  }

  return (
    <div className='calls-details-page'>
      <div className='calls-details-page-wrapper'>
        {backBtnText && <BackButton text={backBtnText} onClickBackButton={onClickBackButton} />}
        {currentView}
        <CallDetailsPopUp type={'WithoutService'} />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    page: state.personalAreaInvoicesPage.callsDetailsPage.page,
    previousPage: state.personalAreaInvoicesPage.callsDetailsPage.previousPage,
    subscribers: state.personalAreaInvoicesPage.callsDetailsPage.subscribers,
    callsDetails: state.personalAreaInvoicesPage.callsDetailsPage.callsDetails,
    showSortingPopup: state.personalAreaInvoicesPage.callsDetailsPage.sorting.showSortingPopup,
    sortingData: state.personalAreaInvoicesPage.callsDetailsPage.sorting.sortingData,
    selectedSort: state.personalAreaInvoicesPage.callsDetailsPage.sorting.selectedSort,
    loginParam: state.personalAreaInvoicesPage.callsDetailsPage.loginParam,
    loginError: state.personalAreaInvoicesPage.callsDetailsPage.loginError,
  };
};
const mapDispatchToProps = {
  getCallsLogAuthAsync,
  getCallsMainAsync,
  getCallsListAsync,
  getCallsLogAuthCheckLoginAsync,
  resetPageCallsDetails,
  setShowSortingPopup,
  saveCallsSorting,
  resetSortingData,
  resetLoginErrorCallDetails,
  selectedCallType,
  goToPage,
  setCallsDetailsPopUp,
};

export default connect(mapStateToProps, mapDispatchToProps)(CallsDetailsPage);
